module.exports = __webpack_public_path__ + "static/amanda_hunter-d36375c44a315d19d686a8e7f232595b.jpg";